import _property from 'lodash/property';

var id = _property('id');

var code = _property('code');

var description = _property('description');

var priceCodeReader = {
  id: id,
  code: code,
  description: description
};
export default priceCodeReader;